import { AdvancedPlan, BasicPlan, EnterprisePlan, Plan, PremiumPlan, Restaurant } from "@/model/entities";
import i18n from "@/i18n";

export const getPlan = (restaurant: Restaurant): Plan => {
    if (!restaurant || !restaurant.plan) {      
      return BasicPlan;
    }
    switch (restaurant.plan) {
      case "basic":        
        return BasicPlan;
      case "advanced":
        return AdvancedPlan;
      case "premium":
        return PremiumPlan;
      case "enterprise":        
        return EnterprisePlan;
      default:        
        return BasicPlan;
    }
  }

export const isAllowedToAddCategory = (plan: Plan | undefined, currentCategories: number) => {
    if (!plan) {
        console.error("[isAllowedToAddCategory] Plan is undefined");
        return false;
    }
    // Enterprise plan has unlimited categories (maxCategories = -1)
    if (plan.planType === "enterprise" || plan.maxCategories === -1) {        
        return true;
    }
    if (plan.planType === "basic") {
        return currentCategories < plan.maxCategories;
    } else if (plan.planType === "advanced") {
        return currentCategories < plan.maxCategories;
    } else if (plan.planType === "premium") {
        return currentCategories < plan.maxCategories;
    }
    return false;
}

export const getCategoryLimitReachedMessage = (plan: Plan | undefined) => {
    if (!plan) {
        console.error("[getCategoryLimitReachedMessage] Plan is undefined");
        return i18n.t("plan.categoryLimitReached", { count: 0 });
    }
    return i18n.t("plan.categoryLimitReached", { count: plan.maxCategories });
}

export const isAllowedToAddMenuItem = (plan: Plan | undefined, currentMenuItems: number) => {
    if (!plan) {
        console.error("[isAllowedToAddMenuItem] Plan is undefined");
        return false;
    }
    // Enterprise plan has unlimited menu items (maxMenuItems = -1)
    if (plan.planType === "enterprise" || plan.maxMenuItems === -1) {
        return true;
    }
    if (plan.planType === "basic") {
        return currentMenuItems < plan.maxMenuItems;
    } else if (plan.planType === "advanced") {
        return currentMenuItems < plan.maxMenuItems;
    } else if (plan.planType === "premium") {
        return currentMenuItems < plan.maxMenuItems;
    }
    return false;
}

export const getMenuItemLimitReachedMessage = (plan: Plan | undefined) => {
    if (!plan) {
        console.error("[getMenuItemLimitReachedMessage] Plan is undefined");
        return i18n.t("plan.menuItemLimitReached", { count: 0 });
    }
    return i18n.t("plan.menuItemLimitReached", { count: plan.maxMenuItems });
}